module.exports = __webpack_public_path__ + "fonts/1d77cf804e1c37bcb4bd0b7fc2a70208-Roboto-LightItalic.woff";